var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 55,
    viewBox: "0 0 44 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6995 43.8087H0.421246V35.0435L22.8039 0.37391H36.1082V35.513H43.543V43.8087H36.1082V55H25.6995V43.8087ZM25.9343 35.513V26.2783C25.9343 19.8087 26.0386 13.8609 26.2473 8.43478H26.0908C25.1517 10.2609 23.8995 12.5043 22.3343 15.1652C20.8212 17.7739 19.4908 20.0174 18.343 21.8957L9.89081 35.513H25.9343Z",
    fill: "#0B5ED7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.a2722fba82768f69b486aea32741bf5f.svg";
export { ForwardRef as ReactComponent };